module.exports = __webpack_public_path__ + "static/media/github.272b63d0.svg";